import { useContext, useEffect, useState } from "react";
import Button from "../atoms/button";
import Loading from "../atoms/loading";
import ToastContext from "../../context/toastProvider";
import { listProductPackages } from "./functions";
import PackageEditor from "./packageEditor";
import ProductPackagesList from "./productPackagesList";

const ProductPackages = ({ user }) => {
    const { badToast, goodToast } = useContext(ToastContext);
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState("");
    const [isActive, setIsActive] = useState("");
    const [editingPackage, setEditingPackage] = useState(null);
    const [showEditor, setShowEditor] = useState(false);

    const loadPackages = async () => {
        setLoading(true);
        const data = await listProductPackages(user?.token, {
            q,
            isActive: isActive === "" ? undefined : isActive === "true",
        });
        if (data?.type === "success") {
            setPackages(data.data || []);
        } else {
            setPackages([]);
            badToast(data?.message || "Erro ao buscar pacotes.");
        }
        setLoading(false);
    };

    useEffect(() => {
        loadPackages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCreate = () => {
        setEditingPackage(null);
        setShowEditor(true);
    };

    const handleEdit = (productPackage) => {
        setEditingPackage(productPackage);
        setShowEditor(true);
    };

    const handleSaved = async () => {
        goodToast("Pacote salvo com sucesso.");
        setShowEditor(false);
        setEditingPackage(null);
        await loadPackages();
    };

    if (showEditor) {
        return (
            <main className="p-4 text-center">
                <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-[#d59106] pb-3 text-left">
                    <div>
                        <h1 className="text-2xl font-semibold text-[#d59106]">Pacotes</h1>
                        <p className="text-sm text-primary/70">Editor desktop de pacote promocional.</p>
                    </div>
                    <Button
                        classes="bg-[#d59106] hover:bg-[#b47c06]"
                        click={() => {
                            setShowEditor(false);
                            setEditingPackage(null);
                        }}
                    >
                        Voltar para lista
                    </Button>
                </div>
                <PackageEditor
                    token={user?.token}
                    productPackage={editingPackage}
                    onCancel={() => {
                        setShowEditor(false);
                        setEditingPackage(null);
                    }}
                    onSaved={handleSaved}
                />
            </main>
        );
    }

    return (
        <main className="p-4 text-center">
            <h1 className="text-2xl font-semibold text-[#d59106]">Pacotes</h1>
            <div className="mt-3 flex flex-wrap items-end justify-center gap-3 border-b border-t border-[#d59106] p-3">
                <label className="text-left text-sm font-semibold text-primary">
                    Buscar
                    <input
                        type="text"
                        value={q}
                        onChange={(event) => setQ(event.target.value)}
                        placeholder="Nome, título ou slug"
                        className="block rounded border border-[#d59106]/50 bg-black px-2 py-1 text-primary outline-none"
                    />
                </label>
                <label className="text-left text-sm font-semibold text-primary">
                    Status
                    <select
                        value={isActive}
                        onChange={(event) => setIsActive(event.target.value)}
                        className="block rounded border border-[#d59106]/50 bg-black px-2 py-1 text-primary outline-none"
                    >
                        <option value="">Todos</option>
                        <option value="true">Ativos</option>
                        <option value="false">Inativos</option>
                    </select>
                </label>
                <Button classes="bg-[#d59106] hover:bg-[#b47c06]" click={loadPackages}>
                    Pesquisar
                </Button>
                <Button classes="bg-blue-300 hover:bg-blue-400" click={handleCreate}>
                    Criar pacote
                </Button>
            </div>
            {loading ? (
                <Loading classes="m-auto mt-8" />
            ) : (
                <ProductPackagesList packages={packages} onCreate={handleCreate} onEdit={handleEdit} />
            )}
        </main>
    );
};

export default ProductPackages;
